import { ROUTE_PATH } from "./common/constants/app.constant";
import { RouteObject } from "react-router";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";

import { Navigate } from "react-router-dom";
import { INavItem } from "./models/app";
import DashboardLayout from "./components/dashboard/DashboardLayout";
import UnAuthLayout from "./components/dashboard/UnAuthLayout";

import Material from "./pages/Material/Material";
// import TimeoffIcon from "./assets/images/sidebar/icon_timeoff_line_grey.svg";
// import TimeoffIconActive from "./assets/images/sidebar/icon_timeoff_active.svg";
import TimeoffIcon from "./assets/images/navbar/timeoff-icon.svg";
import TimeoffIconActive from "./assets/images/navbar/timeoff-icon.svg";
import TypeTimeoffIcon from "./assets/images/sidebar/icon_type_timeoff_line_grey.svg";
import TypeTimeoffIconActive from "./assets/images/sidebar/icon_type_timeoff_active.svg";
import WorkflowIcon from "./assets/images/sidebar/icon_workflow_line_grey.svg";
import WorkflowIconActive from "./assets/images/sidebar/icon_workflow_active.svg";
import MyProjectIcon from "./assets/images/sidebar/icon_myproject_line_grey.svg";
import MyProjectIconActive from "./assets/images/sidebar/icon_myproject_active.svg";
import ScheduleIcon from "./assets/images/sidebar/icon_booking.svg";
import ScheduleIconActive from "./assets/images/sidebar/icon_booking_active.svg";
import ApproveIcon from "./assets/images/common/approve.svg";
import ApproveIconActive from "./assets/images/common/approve.svg";
import RulesIconActive from "./assets/images/sidebar/rules.svg";
import RulesIcon from "./assets/images/sidebar/rules.svg";
import LegalIconActive from "./assets/images/sidebar/legal_active.svg";
import LegalIcon from "./assets/images/sidebar/legal.svg";
import payrollIcon from "./assets/images/sidebar/payroll.svg";
import AidocxIcoin from "./assets/images/navbar/Aidocx.png";
import WorkflowManagement from "./pages/WorkflowManagement/workflow_manage";
import ManageProject from "./pages/ManageProject/ManageProject";
import Account from "./pages/Account/Account";
import Member from "./pages/Member/Member";
import AccountInfo from "./pages/AccountInfo/AccountInfo";
import SupervisorAccountRoundedIcon from "@mui/icons-material/SupervisorAccountRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import LanRoundedIcon from "@mui/icons-material/LanRounded";
import Notification from "./pages/Notification/Notification";
import TaskDetail from "./pages/ManageProject/Task/components/JobDetail/JobDetail";
import Department from "./pages/Department/Department";
import DetailDepartment from "./pages/Department/components/DetailDepartment/DetailDepartment";
import Company from "./pages/Company/Company";
import DetailCompany from "./pages/Company/components/DetailCompany/DetailCompany";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import FileReviewPage from "./pages/ManageProject/FileViewer";
import Booking from "./pages/Booking/Booking";
import TimeOffPage from "./pages/TimeOff/TimeOff";
import TaskStatusChart from "./pages/ManageProject/TaskStatusChart";

import {
  DepartMentPermissionModel,
  DocumentPermissionModel,
  FeatureModel,
  HRPermissionModel,
  MeetingRoomSchedulePermissionModel,
  OpenAiPermissionModel,
  PayRollPermissionModel,
  RulesPermissionModel,
  TimeOffTypePermissionModel
} from "./models/common/models.enum";
import { IFeaturePermission } from "./models/user/models.roles";
import Approve from "./pages/Booking/Approve";
import TimeOffType from "./pages/TimeOffType/TimeOffType";
import Rules from "./pages/Rules/Rules";
import { IWorkflowByTypeResponse } from "./models/workflow";
import Docs from "./pages/Docs/Docs";
import Forbidden from "./pages/Forbidden";
import Unauthorized from "./pages/Unauthorized";
import { jwtDecode } from "jwt-decode";
import GADS from "./pages/Gads";
import GCSL from "./pages/Gcsl";
import { ITokenPayload } from "./models/user";
import { AdminChatDashboard } from "./components/AdminChatDashboard";
import ChatIcon from "./assets/images/common/chat_square_line_chat_line.svg";
import Summary from "./pages/Summary/Summary";
import SummaryAdmin from "./pages/SummaryAdmin/SummaryAdmin";

import WorkflowIconNav from "./assets/images/navbar/workflow.svg";
import SummaryIcon from "./assets/images/navbar/summary.svg";
import DriveIcon from "./assets/images/navbar/drive.svg";
import TimeOffIcon from "./assets/images/navbar/timeoff.svg";
import MeetingIcon from "./assets/images/navbar/meeting.svg";
import OfficeIcon from "./assets/images/navbar/office.svg";
import GoogleAdsIcon from "./assets/images/navbar/googleads.svg";
import AdminChatIcon from "./assets/images/navbar/adminchat.svg";
import ChartIcon from "./assets/images/navbar/chart.svg";
import PayRoll from "./pages/PayRoll/PayRoll";
import ReadDocxAI from "./pages/ChatGpt/ReadDocxAI";
import N8NWorkflows from "./pages/N8NWorkflows/N8NWorkflows";

export const sidebarItems = (
  features?: IFeaturePermission[],
  projects?: IWorkflowByTypeResponse[]
): INavItem[] => {
  const WORKFLOWS: INavItem = {
    title: "Management.Workflow",
    code: "WORK",
    icon: { default: WorkflowIconNav, active: WorkflowIconNav },
    supportUrl: "http://localhost:3000/summary",
    children: [
      {
        title: "Quản lý quy trình",
        code: ROUTE_PATH.WORKFLOWS_MANAGEMENT,
        href: ROUTE_PATH.WORKFLOWS_MANAGEMENT,
        supportUrl: "http://localhost:3000/summary",
        // icon: { default: WorkflowIcon, active: WorkflowIconActive },
        icon: { default: WorkflowIcon, active: WorkflowIconActive },
        children: [
          ...(projects ?? []).map(project => ({
            title: project.typeBoard,
            code: "project",
            // Lấy icon từ board đầu tiên của project group (nếu không có thì không hiển thị)
            ...(project.boards[0]?.icon
              ? {
                  icon: {
                    default: project.boards[0]?.icon,
                    active: project.boards[0]?.icon
                  }
                }
              : {}),
            children: project.boards.map(e => ({
              title: e.name,
              code: e.id,
              search: `${e.id}`,
              href: ROUTE_PATH.PROJECTS,
              // icon: { default: WorkflowIcon, active: WorkflowIconActive }
              icon: {
                default: e.icon || WorkflowIcon,
                active: e.icon || WorkflowIcon
              }
            }))
          }))
        ]
      }
    ]

    // [
    //   {
    //     title: "Quản lý quy trình",
    //     code: ROUTE_PATH.WORKFLOWS_MANAGEMENT,
    //     href: ROUTE_PATH.WORKFLOWS_MANAGEMENT,
    //     icon: { default: WorkflowIcon, active: WorkflowIconActive }
    //   },
    //   ...(projects ?? []).map(project => ({
    //     title: project.typeBoard.toUpperCase(),
    //     code: "project",
    //     children: project.boards.map(e => ({
    //       title: e.name,
    //       code: e.id,
    //       search: `?id=${e.id}`,
    //       href: ROUTE_PATH.PROJECTS,
    //       icon: { default: WorkflowIcon, active: WorkflowIconActive }
    //     }))
    //   }))
    // ]
  };

  const SUMMARY: INavItem = {
    title: "Sidebar.Statistics",
    code: "SUMMARY",
    icon: { default: ChartIcon, active: ChartIcon },
    supportUrl: "http://localhost:3000/summary",
    children: [
      {
        title: "Sidebar.Statistics",
        code: ROUTE_PATH.SUMMARY,
        href: ROUTE_PATH.SUMMARY,
        icon: { default: WorkflowIcon, active: WorkflowIconActive }
      }
    ]
  };

  const SUMMARY_ADMIN: INavItem = {
    title: "Sidebar.AdminStatistics",
    code: "SUMMARY_ADMIN",
    icon: { default: ChartIcon, active: ChartIcon },
    supportUrl: "http://localhost:3000/summary-admin",
    children: [
      {
        title: "Quản lý tổng thể",
        code: ROUTE_PATH.SUMMARY_ADMIN,
        href: ROUTE_PATH.SUMMARY_ADMIN,
        icon: { default: WorkflowIcon, active: WorkflowIconActive }
      }
    ]
  };

  const STATISTICAL: INavItem = {
    title: "STATISTICAL",
    code: "STATISTICAL",
    icon: { default: WorkflowIconNav, active: "" },
    children: [
      {
        title: "Management.WorkflowManagement",
        code: ROUTE_PATH.STATISTICAL,
        href: ROUTE_PATH.STATISTICAL,
        icon: { default: WorkflowIcon, active: WorkflowIconActive },
        children: [
          ...(projects ?? []).map(project => ({
            title: project.typeBoard,
            code: "project",
            children: project.boards.map(e => ({
              title: e.name,
              code: e.id,
              search: `${e.id}`,
              href: ROUTE_PATH.PROJECTS,
              icon: { default: WorkflowIcon, active: WorkflowIconActive }
            }))
          }))
        ]
      }
    ]
  };

  const DRIVE: INavItem = {
    title: "DRIVE",
    code: "DRIVE",
    href: ROUTE_PATH.DRIVER,
    icon: { default: WorkflowIconNav, active: DriveIcon },
    children: [
      {
        title: "Driver",
        code: ROUTE_PATH.DRIVER,
        href: ROUTE_PATH.DRIVER,
        icon: { default: WorkflowIcon, active: WorkflowIconActive }
      }
    ]
  };

  const GOOGLEAS: INavItem = {
    title: "GADS",
    code: "GADS",
    //href : ROUTE_PATH.DRIVER
    icon: { default: GoogleAdsIcon, active: GoogleAdsIcon },
    children: [
      {
        title: "Google Ads",
        code: ROUTE_PATH.GADS,
        href: ROUTE_PATH.GADS,
        icon: { default: WorkflowIcon, active: WorkflowIconActive }
      },
      {
        title: "Google Consonle",
        code: ROUTE_PATH.GCSL,
        href: ROUTE_PATH.GCSL,
        icon: { default: TypeTimeoffIcon, active: TypeTimeoffIconActive }
      }
    ]
  };

  var TIMEOFF: INavItem = {
    title: "TimeOff.PageTitle",
    code: "TimeOff",
    icon: { default: TimeOffIcon, active: TimeOffIcon },
    children: [
      {
        title: "TimeOff.PageTitle",
        code: ROUTE_PATH.TIMEOFF,
        href: ROUTE_PATH.TIMEOFF,
        icon: { default: TimeoffIcon, active: TimeoffIconActive }
      },
      ...(features?.find(
        feature => feature.feature === FeatureModel.TimeOffType
      )
        ? [
            {
              title: "TimeOffType.Title",
              code: ROUTE_PATH.TIMEOFFTYPE,
              href: ROUTE_PATH.TIMEOFFTYPE,
              icon: { default: TypeTimeoffIcon, active: TypeTimeoffIconActive }
            }
          ]
        : [])
    ]
  };

  var MEETING: INavItem = {
    title: "Management.MeetingSchedule",
    code: "Meeting",
    icon: { default: MeetingIcon, active: MeetingIcon },
    children: [
      {
        title: "Management.MeetingSchedule",
        code: ROUTE_PATH.BOOKING,
        href: ROUTE_PATH.BOOKING,
        icon: { default: ScheduleIcon, active: ScheduleIconActive }
      }
    ]
  };
  if (
    features?.find(
      feature =>
        feature.feature === FeatureModel.MeetingRoomSchedule &&
        feature.permissions.includes(
          MeetingRoomSchedulePermissionModel.AdminUpdateStatus
        )
    )
  ) {
    MEETING = {
      ...MEETING,
      children: [
        ...(MEETING?.children ?? []),
        {
          title: "MeetingRoom.Confirm.ApproveSubmit",
          code: "MeetingRoom.Confirm.ApproveSubmit",
          href: ROUTE_PATH.APPROVE,
          icon: { default: ApproveIcon, active: ApproveIconActive }
        }
      ]
    };
  }

  const OFFICE: INavItem = {
    title: "Docs.DocumentForm.Document",
    icon: { default: OfficeIcon, active: OfficeIcon },
    code: "Office",
    children: [
      ...(features?.find(feature => feature.feature === FeatureModel.Document)
        ? [
            {
              title: "Summary.Notifications",
              code: "docs",
              href: ROUTE_PATH.DOCS,
              icon: { default: LegalIcon, active: LegalIconActive }
            }
          ]
        : []),
      ...(features?.find(
        feature =>
          feature.feature === FeatureModel.Rules &&
          feature.permissions.includes(RulesPermissionModel.View)
      )
        ? [
            {
              title: "Rules.Title",
              code: "rules",
              href: ROUTE_PATH.RULES,
              icon: { default: RulesIcon, active: RulesIconActive }
            }
          ]
        : [])
    ]
  };

  const MATERIAL: INavItem = {
    title: "Material",
    icon: {
      default: WorkflowIconNav,
      active:
        "<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'> <path fill-rule='evenodd' clip-rule='evenodd' d='M6.448 1.75C5.54954 1.74997 4.8003 1.74995 4.20552 1.82991C3.57773 1.91432 3.01093 2.09999 2.55546 2.55546C2.09999 3.01093 1.91432 3.57773 1.82991 4.20552C1.74995 4.8003 1.74997 5.54951 1.75 6.44798V6.552C1.74997 7.45047 1.74995 8.19971 1.82991 8.79448C1.91432 9.42228 2.09999 9.98908 2.55546 10.4445C3.01093 10.9 3.57773 11.0857 4.20552 11.1701C4.8003 11.2501 5.54951 11.25 6.44798 11.25H6.552C7.45047 11.25 8.19971 11.2501 8.79448 11.1701C9.42228 11.0857 9.98908 10.9 10.4445 10.4445C10.9 9.98908 11.0857 9.42228 11.1701 8.79448C11.2501 8.19971 11.25 7.4505 11.25 6.55203V6.44801C11.25 5.54954 11.2501 4.8003 11.1701 4.20552C11.0857 3.57773 10.9 3.01093 10.4445 2.55546C9.98908 2.09999 9.42228 1.91432 8.79448 1.82991C8.19971 1.74995 7.4505 1.74997 6.55203 1.75H6.448ZM3.61612 3.61612C3.74644 3.4858 3.94393 3.37858 4.4054 3.31654C4.88843 3.2516 5.53599 3.25 6.5 3.25C7.46401 3.25 8.11157 3.2516 8.59461 3.31654C9.05607 3.37858 9.25357 3.4858 9.38389 3.61612C9.5142 3.74644 9.62143 3.94393 9.68347 4.4054C9.74841 4.88843 9.75 5.53599 9.75 6.5C9.75 7.46401 9.74841 8.11157 9.68347 8.59461C9.62143 9.05607 9.5142 9.25357 9.38389 9.38389C9.25357 9.5142 9.05607 9.62143 8.59461 9.68347C8.11157 9.74841 7.46401 9.75 6.5 9.75C5.53599 9.75 4.88843 9.74841 4.4054 9.68347C3.94393 9.62143 3.74644 9.5142 3.61612 9.38389C3.4858 9.25357 3.37858 9.05607 3.31654 8.59461C3.2516 8.11157 3.25 7.46401 3.25 6.5C3.25 5.53599 3.2516 4.88843 3.31654 4.4054C3.37858 3.94393 3.4858 3.74644 3.61612 3.61612Z' fill='#AAAAAA'/> <path fill-rule='evenodd' clip-rule='evenodd' d='M17.448 12.75C16.5495 12.75 15.8003 12.7499 15.2055 12.8299C14.5777 12.9143 14.0109 13.1 13.5555 13.5555C13.1 14.0109 12.9143 14.5777 12.8299 15.2055C12.7499 15.8003 12.75 16.5495 12.75 17.448V17.552C12.75 18.4505 12.7499 19.1997 12.8299 19.7945C12.9143 20.4223 13.1 20.9891 13.5555 21.4445C14.0109 21.9 14.5777 22.0857 15.2055 22.1701C15.8003 22.2501 16.5495 22.25 17.4479 22.25H17.552C18.4504 22.25 19.1997 22.2501 19.7945 22.1701C20.4223 22.0857 20.9891 21.9 21.4445 21.4445C21.9 20.9891 22.0857 20.4223 22.1701 19.7945C22.2501 19.1997 22.25 18.4505 22.25 17.5521V17.448C22.25 16.5496 22.2501 15.8003 22.1701 15.2055C22.0857 14.5777 21.9 14.0109 21.4445 13.5555C20.9891 13.1 20.4223 12.9143 19.7945 12.8299C19.1997 12.7499 18.4505 12.75 17.552 12.75H17.448ZM14.6161 14.6161C14.7464 14.4858 14.9439 14.3786 15.4054 14.3165C15.8884 14.2516 16.536 14.25 17.5 14.25C18.464 14.25 19.1116 14.2516 19.5946 14.3165C20.0561 14.3786 20.2536 14.4858 20.3839 14.6161C20.5142 14.7464 20.6214 14.9439 20.6835 15.4054C20.7484 15.8884 20.75 16.536 20.75 17.5C20.75 18.464 20.7484 19.1116 20.6835 19.5946C20.6214 20.0561 20.5142 20.2536 20.3839 20.3839C20.2536 20.5142 20.0561 20.6214 19.5946 20.6835C19.1116 20.7484 18.464 20.75 17.5 20.75C16.536 20.75 15.8884 20.7484 15.4054 20.6835C14.9439 20.6214 14.7464 20.5142 14.6161 20.3839C14.4858 20.2536 14.3786 20.0561 14.3165 19.5946C14.2516 19.1116 14.25 18.464 14.25 17.5C14.25 16.536 14.2516 15.8884 14.3165 15.4054C14.3786 14.9439 14.4858 14.7464 14.6161 14.6161Z' fill='#AAAAAA'/> <path fill-rule='evenodd' clip-rule='evenodd' d='M6.448 12.75H6.552C7.45048 12.75 8.1997 12.7499 8.79448 12.8299C9.42228 12.9143 9.98908 13.1 10.4445 13.5555C10.9 14.0109 11.0857 14.5777 11.1701 15.2055C11.2501 15.8003 11.25 16.5495 11.25 17.448V17.552C11.25 18.4505 11.2501 19.1997 11.1701 19.7945C11.0857 20.4223 10.9 20.9891 10.4445 21.4445C9.98908 21.9 9.42228 22.0857 8.79448 22.1701C8.19971 22.2501 7.45051 22.25 6.55206 22.25H6.44801C5.54955 22.25 4.80029 22.2501 4.20552 22.1701C3.57773 22.0857 3.01093 21.9 2.55546 21.4445C2.09999 20.9891 1.91432 20.4223 1.82991 19.7945C1.74995 19.1997 1.74997 18.4505 1.75 17.552V17.448C1.74997 16.5495 1.74995 15.8003 1.82991 15.2055C1.91432 14.5777 2.09999 14.0109 2.55546 13.5555C3.01093 13.1 3.57773 12.9143 4.20552 12.8299C4.8003 12.7499 5.54952 12.75 6.448 12.75ZM4.4054 14.3165C3.94393 14.3786 3.74644 14.4858 3.61612 14.6161C3.4858 14.7464 3.37858 14.9439 3.31654 15.4054C3.2516 15.8884 3.25 16.536 3.25 17.5C3.25 18.464 3.2516 19.1116 3.31654 19.5946C3.37858 20.0561 3.4858 20.2536 3.61612 20.3839C3.74644 20.5142 3.94393 20.6214 4.4054 20.6835C4.88843 20.7484 5.53599 20.75 6.5 20.75C7.46401 20.75 8.11157 20.7484 8.59461 20.6835C9.05607 20.6214 9.25357 20.5142 9.38389 20.3839C9.5142 20.2536 9.62143 20.0561 9.68347 19.5946C9.74841 19.1116 9.75 18.464 9.75 17.5C9.75 16.536 9.74841 15.8884 9.68347 15.4054C9.62143 14.9439 9.5142 14.7464 9.38389 14.6161C9.25357 14.4858 9.05607 14.3786 8.59461 14.3165C8.11157 14.2516 7.46401 14.25 6.5 14.25C5.53599 14.25 4.88843 14.2516 4.4054 14.3165Z' fill='#AAAAAA'/> <path fill-rule='evenodd' clip-rule='evenodd' d='M17.448 1.75C16.5495 1.74997 15.8003 1.74995 15.2055 1.82991C14.5777 1.91432 14.0109 2.09999 13.5555 2.55546C13.1 3.01093 12.9143 3.57773 12.8299 4.20552C12.7499 4.8003 12.75 5.54952 12.75 6.448V6.552C12.75 7.45048 12.7499 8.1997 12.8299 8.79448C12.9143 9.42228 13.1 9.98908 13.5555 10.4445C14.0109 10.9 14.5777 11.0857 15.2055 11.1701C15.8003 11.2501 16.5495 11.25 17.448 11.25H17.552C18.4505 11.25 19.1997 11.2501 19.7945 11.1701C20.4223 11.0857 20.9891 10.9 21.4445 10.4445C21.9 9.98908 22.0857 9.42228 22.1701 8.79448C22.2501 8.19971 22.25 7.4505 22.25 6.55203V6.44801C22.25 5.54954 22.2501 4.8003 22.1701 4.20552C22.0857 3.57773 21.9 3.01093 21.4445 2.55546C20.9891 2.09999 20.4223 1.91432 19.7945 1.82991C19.1997 1.74995 18.4505 1.74997 17.552 1.75H17.448ZM14.6161 3.61612C14.7464 3.4858 14.9439 3.37858 15.4054 3.31654C15.8884 3.2516 16.536 3.25 17.5 3.25C18.464 3.25 19.1116 3.2516 19.5946 3.31654C20.0561 3.37858 20.2536 3.4858 20.3839 3.61612C20.5142 3.74644 20.6214 3.94393 20.6835 4.4054C20.7484 4.88843 20.75 5.53599 20.75 6.5C20.75 7.46401 20.7484 8.11157 20.6835 8.59461C20.6214 9.05607 20.5142 9.25357 20.3839 9.38389C20.2536 9.5142 20.0561 9.62143 19.5946 9.68347C19.1116 9.74841 18.464 9.75 17.5 9.75C16.536 9.75 15.8884 9.74841 15.4054 9.68347C14.9439 9.62143 14.7464 9.5142 14.6161 9.38389C14.4858 9.25357 14.3786 9.05607 14.3165 8.59461C14.2516 8.11157 14.25 7.46401 14.25 6.5C14.25 5.53599 14.2516 4.88843 14.3165 4.4054C14.3786 3.94393 14.4858 3.74644 14.6161 3.61612Z' fill='#AAAAAA'/> </svg>"
    },
    children: [
      {
        title: "Material",
        code: "Material",
        href: ROUTE_PATH.MATERIAL,
        icon: { default: MyProjectIcon, active: MyProjectIconActive }
      }
    ]
  };

  const RULE = {
    title: "Rules.Title",
    code: "Rule",
    href: ROUTE_PATH.RULES,
    icon: { default: RulesIcon, active: RulesIconActive },
    children: [
      {
        title: "Rules",
        code: "rules",
        href: ROUTE_PATH.RULES,
        icon: { default: RulesIcon, active: RulesIconActive }
      }
    ]
  };

  const N8N_WORKFLOWS: INavItem = {
    title: "N8N Workflows",
    code: "N8N_WORKFLOWS",
    icon: { default: WorkflowIconActive, active: WorkflowIconActive },
    children: [
      {
        title: "N8N Workflows",
        code: ROUTE_PATH.N8N_WORKFLOWS,
        href: ROUTE_PATH.N8N_WORKFLOWS,
        icon: { default: WorkflowIconActive, active: WorkflowIconActive }
      }
    ]
  };

  //let navs: INavItem[] = [WORKFLOWS, OFFICE, TIMEOFF, MEETING, STATISTICAL];
  let navs: INavItem[] = [
    WORKFLOWS,
    N8N_WORKFLOWS,
    OFFICE,
    TIMEOFF,
    MEETING,
    DRIVE,
    RULE
  ];

  if (process.env.NODE_ENV === "development") {
    // navs.push(MATERIAL);
    // navs.push(DEVELOPMENT);
  }

  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decoded = jwtDecode<ITokenPayload>(token);
      const isCompany = decoded.isCompany === "True";
      // const su = decoded.role === "SuperAdmin";
      const isSuperAdmin = decoded.isSupperAdmin === "True";

      if (isCompany) navs.push(GOOGLEAS);

      if (isSuperAdmin) {
        const ADMIN_CHAT: INavItem = {
          title: "ADMIN CHAT",
          icon: { default: AdminChatIcon, active: AdminChatIcon },
          code: "admin-chat",
          children: [
            {
              title: "Admin Chat",
              code: "admin-chat",
              href: ROUTE_PATH.ADMIN_CHAT,
              icon: { default: MyProjectIcon, active: MyProjectIconActive }
            }
          ]
        };

        navs.push(SUMMARY_ADMIN);
        navs.push(ADMIN_CHAT);
      } else {
        navs.push(SUMMARY);
      }

      const READDOCXAI: INavItem = {
        title: "AI Assistant",
        icon: { default: AidocxIcoin, active: AidocxIcoin },
        code: "ai-assistant",
        children: [
          {
            title: "Ai assistant",
            code: "ai-assistant",
            href: ROUTE_PATH.DOCXAI,
            icon: { default: AidocxIcoin, active: AidocxIcoin }
          }
        ]
      };
      if (
        features?.find(
          feature =>
            feature.feature === FeatureModel.OpenAi &&
            feature.permissions.includes(OpenAiPermissionModel.View)
        )
      ) {
        navs.push(READDOCXAI);
      }
      const TYPE_OFF_TIME: INavItem = {
        title: "TimeOffType.Title",
        icon: { default: TypeTimeoffIcon, active: TypeTimeoffIcon },
        code: "type-off-time",
        children: [
          {
            title: "Type Off Time",
            code: "type-off-time",
            href: ROUTE_PATH.TIMEOFFTYPE,
            icon: { default: TypeTimeoffIcon, active: TypeTimeoffIcon }
          }
        ]
      };

      const APPPROVE: INavItem = {
        title: "Meeting.MeetingManagement",
        icon: { default: ApproveIcon, active: ApproveIcon },
        code: "APPROVE",
        children: [
          {
            title: "Approve",
            code: "APPROVE",
            href: ROUTE_PATH.APPROVE,
            icon: { default: ApproveIcon, active: ApproveIcon }
          }
        ]
      };
      if (
        features?.find(
          feature =>
            feature.feature === FeatureModel.TimeOffType &&
            feature.permissions.includes(TimeOffTypePermissionModel.View)
        )
      ) {
        navs.push(TYPE_OFF_TIME);
      }
      if (
        features?.find(
          feature =>
            feature.feature === FeatureModel.MeetingRoomSchedule &&
            feature.permissions.includes(
              MeetingRoomSchedulePermissionModel.AdminUpdateStatus
            )
        )
      ) {
        navs.push(APPPROVE);
      }

      const PAYROLL: INavItem = {
        title: "Payroll.Title",
        icon: { default: payrollIcon, active: payrollIcon },
        code: "payroll",
        children: [
          {
            title: "Payroll",
            code: "payroll",
            href: ROUTE_PATH.PAYROLL,
            icon: { default: payrollIcon, active: payrollIcon }
          }
        ]
      };
      if (
        features?.find(
          feature =>
            feature.feature === FeatureModel.Payroll &&
            feature.permissions.includes(PayRollPermissionModel.View)
        )
      ) {
        navs.push(PAYROLL);
      }
    } catch (error) {
      console.error("Error decoding token in sidebarItems:", error);
    }
  }

  return navs;
};

export const accountSidebarItems = (features?: IFeaturePermission[]) => {
  const USER = {
    icon: {
      default: <AccountCircleRoundedIcon sx={{ color: "GrayText" }} />,
      active: <AccountCircleRoundedIcon />
    },
    text: "Account.Nav.Personal",
    href: ROUTE_PATH.ACCOUNT
  };

  const MEMBER = {
    icon: {
      default: <SupervisorAccountRoundedIcon sx={{ color: "GrayText" }} />,
      active: <SupervisorAccountRoundedIcon />
    },
    text: "Account.Nav.Member",
    href: ROUTE_PATH.ACCOUNT_MEMBER
  };

  const GROUP = {
    icon: {
      default: <LanRoundedIcon sx={{ color: "GrayText" }} />,
      active: <LanRoundedIcon />
    },
    text: "Account.Nav.Group",
    href: ROUTE_PATH.ACCOUNT_DEPARTMENT
  };

  const COMPANY = {
    icon: {
      default: <LanRoundedIcon sx={{ color: "GrayText" }} />,
      active: <LanRoundedIcon />
    },
    text: "Account.Nav.Company",
    href: ROUTE_PATH.ACCOUNT_COMPANY
  };

  const HOME = {
    icon: {
      default: <HomeRoundedIcon sx={{ color: "GrayText" }} />,
      active: <HomeRoundedIcon />
    },
    text: "Account.Nav.Home",
    href: ROUTE_PATH.INDEX
  };

  let navs = [HOME, USER];

  // giữ nguyên phần check features bên dưới
  if (
    features?.find(
      feature =>
        feature.feature === FeatureModel.HR &&
        feature.permissions.includes(
          HRPermissionModel.ViewListUser ||
            HRPermissionModel.ViewUserRegisterTimeOff
        )
    )
  ) {
    navs.push(MEMBER);
  }

  if (
    features?.find(
      feature =>
        feature.feature === FeatureModel.Department &&
        feature.permissions.includes(
          DepartMentPermissionModel.View || DepartMentPermissionModel.ViewAll
        )
    )
  ) {
    navs.push(GROUP);
  }

  {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode<ITokenPayload>(token);
      const isSupperAdmin = decoded.isSupperAdmin === "True";

      if (isSupperAdmin) navs.push(COMPANY);
    }
  }

  return navs;
};

const appRoutes = (): RouteObject[] => {
  let routes: RouteObject[] = [
    {
      path: ROUTE_PATH.INDEX,
      element: <DashboardLayout />,
      children: [
        { path: "*", element: <Navigate to={ROUTE_PATH.NOTFOUND} /> },
        {
          path: ROUTE_PATH.INDEX,
          element: <Navigate to={ROUTE_PATH.WORKFLOWS_MANAGEMENT} />
        },
        {
          path: ROUTE_PATH.MATERIAL,
          element: <Material />
        },

        {
          path: ROUTE_PATH.WORKFLOWS_MANAGEMENT,
          element: <WorkflowManagement />
        },
        {
          path: ROUTE_PATH.SUMMARY,
          element: <Summary />
        },
        {
          path: ROUTE_PATH.SUMMARY_ADMIN,
          element: <SummaryAdmin />
        },
        {
          path: ROUTE_PATH.PROJECTS,
          element: <ManageProject />
        },
        {
          path: ROUTE_PATH.TASK,
          element: <TaskDetail />
        },
        {
          path: ROUTE_PATH.APPROVE,
          element: <Approve />
        },
        {
          path: ROUTE_PATH.TIMEOFF,
          element: <TimeOffPage />
        },
        {
          path: ROUTE_PATH.TIMEOFFTYPE,
          element: <TimeOffType />
        },
        {
          path: ROUTE_PATH.BOOKING,
          element: <Booking />
        },
        {
          path: ROUTE_PATH.RULES,
          element: <Rules />
        },
        {
          path: ROUTE_PATH.DOCS,
          element: <Docs />
        },
        {
          path: ROUTE_PATH.STATISTICAL,
          element: <TaskStatusChart />
        },
        {
          path: ROUTE_PATH.GADS,
          element: <GADS />
        },
        {
          path: ROUTE_PATH.GCSL,
          element: <GCSL />
        },
        {
          path: ROUTE_PATH.ADMIN_CHAT,
          element: <AdminChatDashboard />
        },
        {
          path: ROUTE_PATH.PAYROLL,
          element: <PayRoll />
        },
        {
          path: ROUTE_PATH.DOCXAI,
          element: <ReadDocxAI />
        },
        {
          path: ROUTE_PATH.N8N_WORKFLOWS,
          element: <N8NWorkflows />
        }
      ]
    },

    {
      path: ROUTE_PATH.INDEX,
      element: <UnAuthLayout />,
      children: [
        {
          path: ROUTE_PATH.LOGIN,
          element: <Login />
        },
        { path: "*", element: <Navigate to={ROUTE_PATH.LOGIN} /> },
        {
          path: ROUTE_PATH.RESOURCE,
          element: <FileReviewPage />
        }
      ]
    },
    {
      path: ROUTE_PATH.NOTFOUND,
      element: <NotFound />
    },
    {
      path: ROUTE_PATH.FORBIDDEN,
      element: <Forbidden />
    },
    {
      path: ROUTE_PATH.UNAUTHORIZED,
      element: <Unauthorized />
    },
    {
      path: ROUTE_PATH.ACCOUNT,
      element: <Account />,
      children: [
        { path: "*", element: <Navigate to={ROUTE_PATH.NOTFOUND} /> },
        {
          path: ROUTE_PATH.ACCOUNT,
          element: <AccountInfo />
        },
        {
          path: ROUTE_PATH.ACCOUNT_NOTI,
          element: <Notification />
        },
        {
          path: ROUTE_PATH.ACCOUNT_MEMBER,
          element: <Member />
        },
        {
          path: ROUTE_PATH.ACCOUNT_DEPARTMENT,
          element: <Department />
          // children: [

          // ]
        },
        {
          path: ROUTE_PATH.ACCOUNT_COMPANY,
          element: <Company />
          // children: [

          // ]
        },
        {
          path: `${ROUTE_PATH.ACCOUNT_COMPANY}/:id`,
          element: <DetailCompany />
        },
        {
          path: `${ROUTE_PATH.ACCOUNT_DEPARTMENT}/:id`,
          element: <DetailDepartment />
        }
      ]
    }
  ];

  return routes;
};

export default appRoutes;
